import type { ReactNode } from 'react';
import { HeaderBar } from './RailHeader.styles';

export function RailHeader({
  title = 'Panels',
  titleId,
  children,
}: {
  title?: string;
  titleId?: string;
  children: ReactNode;
}) {
  return (
    <HeaderBar data-testid="rail-header">
      <h2 id={titleId}>{title}</h2>
      {children}
    </HeaderBar>
  );
}
